<script>
import moment from 'moment'
import { crudMethods } from '@/src/state/helpers'
import DatePicker from 'vue-bootstrap-datetimepicker'
import CommaFormattedNumber from 'vue-comma-formatted-number'
import CompTagihanTable from '@/src/router/views/pages/transaksi/proyek/tagihan/comp-tagihan-table.vue'
import CompTagihanInfo from '@/src/router/views/pages/transaksi/proyek/tagihan/comp-tagihan-info.vue'

export default {
  components: {
    DatePicker,
    CommaFormattedNumber,
    CompTagihanTable,
    CompTagihanInfo,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      apiUrl: '/web/transaksi/proyek',
      title: 'Draft Tagihan',
      items: [],
      itemTemps: [],
      rincianTagihans: [],
      detail: {},
      lamaKontrak: 0,
      kl: false,
      baut: false,
      bast: false,
      modalTagihan: false,
      modalUpload: false,
      modalKonfirmasiDraft: false,
      modalRincianTagihan: false,
      loading: false,
      tanggalMulai: '',
      tanggalBearkhir: '',
      dateOptions: {
        format: 'DD-MM-YYYY',
      },
      statusTagihan: true,
      subTotalTagihan: 0,
      tglTagihanAwal: '',
      tglTagihanAwalOri: '',
      tglTagihanAkhir: '',
      totalTagihan: '',
      bebanSPHVendor: '0',
      tglMin: '',
      tglMax: '',
      mekanismePembayaran: '',
      pembayaranNo: '',
      tanggalDokumenKL: '',
      summarySpkVendor: 0,
      nilaiKontrak: 0,
      jenisTagihan: 'Bulan',
      jumlahTagihan: 0,
      jumlahHari: 0,
      rabs: [],
      rabsTemp: [],
      jenisTagihans: [
        { id: 'Bulan', name: 'Bulan' },
        { id: 'Prorate', name: 'Prorate' },
      ],
      typeDraft: 'new',
      noTagihan: '',
      tanggalBayar: new Date(),
      hitungNormal: false,
      modalBebanVendor: false,
      modalUpdateBayar: false,
    }
  },
  computed: {
    authorizedUser() {
      return (
        this.user.role === 'ROOT' ||
        this.user.role === 'ADMIN' ||
        this.user.role === 'KABAG-ADMINISTRASI-NON-AKSES' ||
        this.user.role === 'KABAG-SALES-DELIVERY'
      )
    },
    checkValidation() {
      return (
        this.uraianJustifikasi === '' ||
        this.volume === '' ||
        this.periode === '' ||
        this.satuan === '' ||
        this.sph === '' ||
        this.sphKali === '' ||
        this.spk === '' ||
        this.spkKali === ''
      )
    },
    validationDraftManual() {
      return (
        this.rabs.filter((x) => x.selected === true).length === 0 ||
        this.jumlahTagihan === 0
      )
    },
    margin() {
      const beban = this.items.reduce(
        (a, b) => a + (b['beban_sph_vendor'] || 0),
        0
      )

      const totalTagihan = this.detail.nilai_kontrak_prorate

      let val = (totalTagihan - beban) / beban

      return val
    },
  },
  watch: {
    jenisTagihan: {
      handler: function(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.jumlahHari = 0
        }
      },
    },
    tglTagihanAkhir: {
      handler: function(newVal, oldVal) {
        this.hitungProrate()
      },
    },
    tglTagihanAwal: {
      handler: function(newVal, oldVal) {
        if (newVal !== oldVal && this.typeDraft === 'new') {
          this.tglTagihanAkhir = newVal
        }
      },
    },
    jumlahHari: {
      handler: function(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.jenisTagihan === 'Prorate') {
            let rabs = JSON.parse(JSON.stringify(this.rabsTemp))
            rabs.forEach((rab) => {
              rab.spk = parseInt(rab.spk) / newVal
            })
            this.rabs = rabs
          } else {
            this.rabs = JSON.parse(JSON.stringify(this.rabsTemp))
          }
        }
      },
    },
  },
  mounted() {
    if (this.user.role !== 'OPERASIONAL') {
      this.checkProyek()
      this.checkRAB()
      this.checkDokumen('kl')
      this.checkDokumen('baut')
      this.checkDokumen('bast')
    }
    this.getList()
    this.getDetail()
  },

  methods: {
    ...crudMethods,
    getList() {
      this.subTotalTagihan = 0
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/tagihan`,
      }).then((response) => {
        const { data } = response.data
        this.items = data
        this.statusTagihan = data.filter(
          (x) => x.status_draft === 'DRAFT'
        ).length
      })
    },
    getDetail() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}`,
      }).then((response) => {
        const { data } = response.data
        this.detail = data
      })
    },
    getRab() {
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/rab`,
      }).then((response) => {
        const { data } = response.data
        let items = []
        let no = 1
        data.forEach((item) => {
          let obj = {
            selected: true,
            no: no,
            proyek_id: item.proyek_id,
            id: item.id,
            uraian_justifikasi: item.uraian_justifikasi,
            volume: item.volume,
            periode: item.periode,
            satuan: item.satuan,
            sph: item.sph,
            sph_kali: item.sph_kali,
            spk: item.spk,
            spk_kali: item.spk_kali,
            proyek_id_header: item.proyek_id_header,
            id_header: item.id_header,
            type_field: item.type_field,
          }

          if (item.subs && item.subs.length > 0) {
            const rowspanSph = item.subs.filter((x) => x.sph === null).length
            const rowspanSpk = item.subs.filter((x) => x.spk === null).length
            const rowspanVolume = item.subs.filter((x) => x.volume === null)
              .length
            const rowspanPeriode = item.subs.filter((x) => x.periode === null)
              .length
            const rowspanSatuan = item.subs.filter((x) => x.satuan === null)
              .length

            obj.rowspan_sph = rowspanSph + 1
            obj.rowspan_spk = rowspanSpk + 1
            obj.rowspan_volume = rowspanVolume + 1
            obj.rowspan_periode = rowspanPeriode + 1
            obj.rowspan_satuan = rowspanSatuan + 1
          }

          items.push(obj)

          item.subs.forEach((sub1) => {
            let obj = {
              selected: true,
              proyek_id: sub1.proyek_id,
              id: sub1.id,
              uraian_justifikasi: sub1.uraian_justifikasi,
              volume: sub1.volume,
              periode: sub1.periode,
              satuan: sub1.satuan,
              sph: sub1.sph,
              sph_kali: sub1.sph_kali,
              spk: sub1.spk,
              spk_kali: sub1.spk_kali,
              proyek_id_header: sub1.proyek_id_header,
              id_header: sub1.id_header,
              type_field: sub1.type_field,
            }
            if (sub1.subs && sub1.subs.length > 0) {
              const rowspanSph = sub1.subs.filter((x) => x.sph === null).length
              const rowspanSpk = sub1.subs.filter((x) => x.spk === null).length
              const rowspanVolume = sub1.subs.filter((x) => x.volume === null)
                .length
              const rowspanPeriode = sub1.subs.filter((x) => x.periode === null)
                .length
              const rowspanSatuan = sub1.subs.filter((x) => x.satuan === null)
                .length

              obj.rowspan_sph = rowspanSph + 1
              obj.rowspan_spk = rowspanSpk + 1
              obj.rowspan_volume = rowspanVolume + 1
              obj.rowspan_periode = rowspanPeriode + 1
              obj.rowspan_satuan = rowspanSatuan + 1
            }

            items.push(obj)
            sub1.subs.forEach((sub2) => {
              let obj = {
                selected: true,
                proyek_id: sub2.proyek_id,
                id: sub2.id,
                uraian_justifikasi: sub2.uraian_justifikasi,
                volume: sub2.volume,
                periode: sub2.periode,
                satuan: sub2.satuan,
                sph: sub2.sph,
                sph_kali: sub2.sph_kali,
                spk: sub2.spk,
                spk_kali: sub2.spk_kali,
                proyek_id_header: sub2.proyek_id_header,
                id_header: sub2.id_header,
                type_field: sub2.type_field,
              }

              if (sub2.subs && sub2.subs.length > 0) {
                const rowspanSph = sub2.subs.filter((x) => x.sph === null)
                  .length
                const rowspanSpk = sub2.subs.filter((x) => x.spk === null)
                  .length
                const rowspanVolume = sub2.subs.filter((x) => x.volume === null)
                  .length
                const rowspanPeriode = sub2.subs.filter(
                  (x) => x.periode === null
                ).length
                const rowspanSatuan = sub2.subs.filter((x) => x.satuan === null)
                  .length

                obj.rowspan_sph = rowspanSph + 1
                obj.rowspan_spk = rowspanSpk + 1
                obj.rowspan_volume = rowspanVolume + 1
                obj.rowspan_periode = rowspanPeriode + 1
                obj.rowspan_satuan = rowspanSatuan + 1
              }
              items.push(obj)
            })
          })
          no++
        })
        this.rabsTemp = items
        this.rabs = items
      })
    },
    hitungProrate() {
      const awal1 = moment(
        moment(this.tglTagihanAwal, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        'YYYY-MM-DD'
      )

      const akhir1 = moment(
        moment(this.tglTagihanAkhir, 'DD-MM-YYYY').format('YYYY-MM-DD'),
        'YYYY-MM-DD'
      )

      const awal2 = moment(
        moment(this.tglTagihanAwal, 'DD-MM-YYYY')
          .startOf('month')
          .format('YYYY-MM-DD'),
        'YYYY-MM-DD'
      )

      const akhir2 = moment(
        moment(this.tglTagihanAkhir, 'DD-MM-YYYY')
          .endOf('month')
          .format('YYYY-MM-DD'),
        'YYYY-MM-DD'
      )

      const jumlahHari = Math.round(akhir2.diff(awal2, 'days', true)) + 1
      const jumlahHariProrate = Math.round(akhir1.diff(awal1, 'days', true)) + 1

      if (this.jenisTagihan === 'Prorate') {
        let rabs = JSON.parse(JSON.stringify(this.rabsTemp))
        this.jumlahTagihan = jumlahHariProrate
        this.jumlahHari = jumlahHari
        rabs.forEach((rab) => {
          rab.spk = parseInt(rab.spk) / jumlahHari
        })
        this.rabs = rabs
      } else {
        this.rabs = JSON.parse(JSON.stringify(this.rabsTemp))
      }
    },
    handleTotalTagihan(e) {
      this.totalTagihan = e
    },
    checkDokumen(tipe) {
      this.getData({
        url: `web/transaksi/proyek/${
          this.$route.params.id
        }/dokumen/${tipe.toUpperCase()}/check`,
      }).then((response) => {
        const { data } = response.data
        if (data !== null) {
          if (data) this[tipe] = true

          if (tipe === 'kl')
            this.tanggalDokumenKL = moment(data.tanggal_dokumen).format(
              'DD-MM-YYYY'
            )
        }
      })
    },
    checkRAB() {
      this.getData({
        url: `web/transaksi/proyek/${this.$route.params.id}/rab`,
      }).then((response) => {
        const { data } = response.data
        if (data !== null) {
          let items = []
          let no = 1
          data.forEach((item) => {
            let obj = {
              no: no,
              proyek_id: item.proyek_id,
              id: item.id,
              uraian_justifikasi: item.uraian_justifikasi,
              volume: item.volume,
              periode: item.periode,
              satuan: item.satuan,
              sph: item.sph,
              sph_kali: item.sph_kali,
              spk: item.spk,
              spk_kali: item.spk_kali,
              proyek_id_header: item.proyek_id_header,
              id_header: item.id_header,
              type_field: item.type_field,
              type_sub: 0,
            }
            items.push(obj)

            item.subs.forEach((sub1) => {
              let obj = {
                proyek_id: sub1.proyek_id,
                id: sub1.id,
                uraian_justifikasi: sub1.uraian_justifikasi,
                volume: sub1.volume,
                periode: sub1.periode,
                satuan: sub1.satuan,
                sph: sub1.sph,
                sph_kali: sub1.sph_kali,
                spk: sub1.spk,
                spk_kali: sub1.spk_kali,
                proyek_id_header: item.proyek_id_header,
                id_header: item.id_header,
                type_field: sub1.type_field,
                type_sub: 1,
              }
              if (sub1.subs && sub1.subs.length > 0) {
                const rowspanSph = sub1.subs.filter((x) => x.sph === null)
                  .length
                const rowspanSpk = sub1.subs.filter((x) => x.spk === null)
                  .length
                const rowspanVolume = sub1.subs.filter((x) => x.volume === null)
                  .length
                const rowspanPeriode = sub1.subs.filter(
                  (x) => x.periode === null
                ).length
                const rowspanSatuan = sub1.subs.filter((x) => x.satuan === null)
                  .length

                obj.rowspan_sph = rowspanSph + 1
                obj.rowspan_spk = rowspanSpk + 1
                obj.rowspan_volume = rowspanVolume + 1
                obj.rowspan_periode = rowspanPeriode + 1
                obj.rowspan_satuan = rowspanSatuan + 1
              }

              items.push(obj)
              sub1.subs.forEach((sub2) => {
                let obj = {
                  proyek_id: sub2.proyek_id,
                  id: sub2.id,
                  uraian_justifikasi: sub2.uraian_justifikasi,
                  volume: sub2.volume,
                  periode: sub2.periode,
                  satuan: sub2.satuan,
                  sph: sub2.sph,
                  sph_kali: sub2.sph_kali,
                  spk: sub2.spk,
                  spk_kali: sub2.spk_kali,
                  proyek_id_header: sub2.proyek_id_header,
                  id_header: sub2.proyek_id,
                  type_field: sub2.type_field,
                  type_sub: 2,
                }

                if (sub2.subs && sub2.subs.length > 0) {
                  const rowspanSph = sub2.subs.filter((x) => x.sph === null)
                    .length
                  const rowspanSpk = sub2.subs.filter((x) => x.spk === null)
                    .length
                  const rowspanVolume = sub2.subs.filter(
                    (x) => x.volume === null
                  ).length
                  const rowspanPeriode = sub2.subs.filter(
                    (x) => x.periode === null
                  ).length
                  const rowspanSatuan = sub2.subs.filter(
                    (x) => x.satuan === null
                  ).length

                  obj.rowspan_sph = rowspanSph + 1
                  obj.rowspan_spk = rowspanSpk + 1
                  obj.rowspan_volume = rowspanVolume + 1
                  obj.rowspan_periode = rowspanPeriode + 1
                  obj.rowspan_satuan = rowspanSatuan + 1
                }
                items.push(obj)
              })
            })
            no++
          })
          const summary = items.reduce(
            (a, b) =>
              a +
              (b['spk'] *
                (b['spk_kali'] !== 'all'
                  ? b[b['spk_kali']]
                  : b['volume'] * b['periode']) || 0),
            0
          )
          this.summarySpkVendor = summary
        }
      })
    },
    checkProyek() {
      this.getData({
        url: `web/transaksi/proyek/${this.$route.params.id}`,
      }).then((response) => {
        const { data } = response.data
        if (data !== null) {
          this.nilaiKontrak = data.nilai_kontrak_belum_ppn
        }
      })
    },
    buatDraft() {
      let rabs = []
      this.rabs.forEach((item) => {
        if (item.selected === true) {
          rabs.push(item.id)
        }
      })
      this.insertData({
        url: `${this.apiUrl}/${this.$route.params.id}/tagihan`,
        body: {
          hitung_normal: this.hitungNormal,
          rabs: rabs,
        },
      })
        .then((response) => {
          const { data } = response
          if (data) {
            this.hitungNormal = false
            this.modalKonfirmasiDraft = false
            this.getList()
            this.getDetail()
            this.toast('b-toaster-bottom-right', true, ' Berhasil Dibuat')
          } else {
            this.errorMsg = data.data
            this.modalError = true
          }
        })
        .catch((err) => {
          let message = JSON.parse(err.response.request.response)
          this.errorMsg = message.message
          this.modalError = true
        })
    },
    showDraftOtomatis() {
      this.getRab()
      this.modalKonfirmasiDraft = true
    },
    showDraftManual() {
      this.typeDraft = 'new'
      this.jumlahTagihan = 0
      this.getRab()
      this.modalTagihan = true
    },
    addDetail(item) {
      this.typeDraft = 'detail'
      this.noTagihan = item.no
      this.tglTagihanAwal = moment(item.tanggal_awal, 'YYYY-MM-DD').format(
        'DD-MM-YYYY'
      )
      this.tglTagihanAkhir = moment(item.tanggal_akhir, 'YYYY-MM-DD').format(
        'DD-MM-YYYY'
      )
      this.getRab()
      this.modalTagihan = true
    },
    draftManual() {
      let body = {
        tanggal_awal: moment(this.tglTagihanAwal, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        ),
        tanggal_akhir: moment(this.tglTagihanAkhir, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        ),
        beban_sph_vendor: this.bebanSPHVendor.replace(/,/g, ''),
        jenis: this.jenisTagihan,
        tagihans: this.rabs.filter((x) => x.selected === true),
        jumlah_tagihan: this.jumlahTagihan,
      }

      let type = 'insertData'
      let url = `${this.apiUrl}/${this.$route.params.id}/tagihan-manual`
      if (this.typeDraft === 'detail') {
        type = 'updateData'
        url = `${this.apiUrl}/${this.$route.params.id}/tagihan-manual/${this.noTagihan}/detail`
      }

      this[type]({
        url: `${url}`,
        body: body,
      })
        .then((response) => {
          const { data } = response
          if (data) {
            this.getList()
            this.getDetail()
            this.toast('b-toaster-bottom-right', true, ' Berhasil Diupdate')
            this.clearForm()
          } else {
            this.errorMsg = data.data
            this.modalError = true
          }
          this.modalTagihan = false
        })
        .catch((err) => {
          let message = JSON.parse(err.response.request.response)
          this.errorMsg = message.message
          this.modalError = true
        })
    },
    resetDraft() {
      this.$bvModal
        .msgBoxConfirm(`Reset draft tagihan dari proyek ini?`, {
          title: 'Mohon Konfirmasi',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YA',
          cancelTitle: 'TIDAK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteData({
              url: `${this.apiUrl}/${this.$route.params.id}/tagihan`,
            })
              .then((response) => {
                this.getList()
                this.getDetail()
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Berhasil Direset',
                  'success'
                )
              })
              .catch((err) => {
                this.loading = false
                let message = JSON.parse(err.response.request.response)
                this.messageError = message.message
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Tidak Dapat Dihapus',
                  'danger'
                )
              })
          }
        })
    },
    removeDraftDetail(item) {
      this.$bvModal
        .msgBoxConfirm(`hapus data ${this.title.toLowerCase()} ini?`, {
          title: 'Mohon Konfirmasi',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YA',
          cancelTitle: 'TIDAK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteData({
              url: `${this.apiUrl}/${item.proyek_id}/tagihan-manual/${item.no_tagihan}/detail/${item.detail_no}`,
            })
              .then((response) => {
                this.getList()
                this.getDetail()
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Berhasil Dihapus',
                  'success'
                )
              })
              .catch((err) => {
                this.loading = false
                let message = JSON.parse(err.response.request.response)
                this.messageError = message.message
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Tidak Dapat Dihapus',
                  'danger'
                )
              })
          }
        })
    },
    removeDraft(noTagihan) {
      this.$bvModal
        .msgBoxConfirm(`hapus data ${this.title.toLowerCase()} ini?`, {
          title: 'Mohon Konfirmasi',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'YA',
          cancelTitle: 'TIDAK',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteData({
              url: `${this.apiUrl}/${this.$route.params.id}/tagihan/${noTagihan}`,
            })
              .then((response) => {
                this.getList()
                this.getDetail()
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Berhasil Dihapus',
                  'success'
                )
              })
              .catch((err) => {
                this.loading = false
                let message = JSON.parse(err.response.request.response)
                this.messageError = message.message
                this.toast(
                  'b-toaster-bottom-right',
                  true,
                  ' Tidak Dapat Dihapus',
                  'danger'
                )
              })
          }
        })
    },
    saveDraft() {
      this.$bvModal
        .msgBoxConfirm(
          'Apakah anda yakin menyimpan draft ini sebagai data final?',
          {
            title: 'Mohon Konfirmasi',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'YA',
            cancelTitle: 'TIDAK',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.updateData({
              url: `${this.apiUrl}/${this.$route.params.id}/tagihan`,
            })
              .then((response) => {
                const { data } = response
                if (data) {
                  this.getList()
                  this.getDetail()
                  this.toast(
                    'b-toaster-bottom-right',
                    true,
                    ' Berhasil Diupdate'
                  )
                } else {
                  this.errorMsg = data.data
                  this.modalError = true
                }
              })
              .catch((err) => {
                let message = JSON.parse(err.response.request.response)
                this.errorMsg = message.message
                this.modalError = true
              })
          }
        })
    },
    getTagihan(index) {
      moment.locale('id')
      const data = this.items[index]
      this.tglMin = moment(this.tanggalMulai, 'YYYY-MM-DD')
      if (index === 0) {
        this.tglMin = moment(this.items[index].tanggal_awal, 'YYYY-MM-DD')
      } else {
        this.tglMin = moment(this.items[index - 1].tanggal_akhir, 'YYYY-MM-DD')
      }

      this.tglTagihanAwal = moment(data.tanggal_awal, 'YYYY-MM-DD').format(
        'DD-MM-YYYY'
      )
      this.tglTagihanAwalOri = moment(data.tanggal_awal, 'YYYY-MM-DD')

      this.tglTagihanAkhir = moment(data.tanggal_akhir, 'YYYY-MM-DD').format(
        'DD-MM-YYYY'
      )
      this.totalTagihan = data.total_tagihan.toString()
      this.mekanismePembayaran =
        this.detail.mekanisme_pembayaran === 'TERMIN'
          ? 'Termin'
          : this.detail.mekanisme_pembayaran === 'MRC'
          ? 'Bulan'
          : 'No.'
      this.pembayaranNo = this.items[index].no
      this.modalTagihan = true
    },
    updateBebanVendor() {
      let body = {
        beban_sph_vendor: this.bebanSPHVendor.replace(/,/g, ''),
      }
      this.updateData({
        url: `web/transaksi/proyek/${this.$route.params.id}/tagihan/${this.noTagihan}/beban-vendor`,
        body: body,
      })
        .then((response) => {
          const { data } = response
          if (data) {
            this.getList()
            this.getDetail()
            this.toast('b-toaster-bottom-right', true, ' Berhasil Dirubah')
            this.modalBebanVendor = false
          } else {
            this.errorMsg = data.data
            this.modalError = true
          }
        })
        .catch((err) => {
          let message = JSON.parse(err.response.request.response)
          this.errorMsg = message.message
          this.modalError = true
        })
    },
    updateRincianTagihan() {
      let body = {
        tagihans: this.rincianTagihans,
      }
      this.updateData({
        url: `web/transaksi/proyek/${this.$route.params.id}/tagihan/${this.noTagihan}/rincian-tagihan`,
        body: body,
      })
        .then((response) => {
          const { data } = response
          if (data) {
            this.getList()
            this.getDetail()
            this.toast('b-toaster-bottom-right', true, ' Berhasil Dirubah')
            this.modalRincianTagihan = false
          } else {
            this.errorMsg = data.data
            this.modalError = true
          }
        })
        .catch((err) => {
          let message = JSON.parse(err.response.request.response)
          this.errorMsg = message.message
          this.modalError = true
        })
    },
    updateTanggalBayar() {
      let body = {
        tanggal_bayar: moment(this.tanggalBayar, 'DD-MM-YYYY').format(
          'YYYY-MM-DD'
        ),
      }
      this.updateData({
        url: `web/transaksi/proyek/${this.$route.params.id}/tagihan/${this.noTagihan}/tanggal-bayar`,
        body: body,
      })
        .then((response) => {
          const { data } = response
          if (data) {
            this.getList()
            this.getDetail()
            this.toast('b-toaster-bottom-right', true, ' Berhasil Dirubah')
            this.modalUpdateBayar = false
          } else {
            this.errorMsg = data.data
            this.modalError = true
          }
        })
        .catch((err) => {
          let message = JSON.parse(err.response.request.response)
          this.errorMsg = message.message
          this.modalError = true
        })
    },
    rincianTagihan(noTagihan) {
      this.noTagihan = noTagihan
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/tagihan/${noTagihan}/rincian-tagihan`,
      }).then((response) => {
        const { data } = response.data
        this.rincianTagihans = data
        this.modalRincianTagihan = true
      })
    },
    rincianBebanVendor(noTagihan) {
      this.noTagihan = noTagihan
      this.listData({
        url: `web/transaksi/proyek/${this.$route.params.id}/tagihan/${noTagihan}`,
      }).then((response) => {
        const { data } = response.data
        this.bebanSPHVendor = data.beban_sph_vendor.toString()
        this.modalBebanVendor = true
      })
    },
    handleHarga(e, item) {
      let jumlah = 0
      const harga = parseInt(e.replace(/,/g, ''))
      if (item.is_qty) {
        jumlah = harga * item.qty * item.periode_tagih
      } else {
        jumlah = harga * item.periode_tagih
      }
      this.rincianTagihans.find(
        (x) =>
          x.no_tagihan === item.no_tagihan && x.detail_no === item.detail_no
      ).harga = harga
      this.rincianTagihans.find(
        (x) =>
          x.no_tagihan === item.no_tagihan && x.detail_no === item.detail_no
      ).jumlah = jumlah
    },
    handleSPK(e, item) {
      const spk = parseInt(e.replace(/,/g, ''))

      this.rabs.find(
        (x) => x.proyek_id === item.proyek_id && x.id === item.id
      ).spk = spk
    },
    handleBebanSPHVendor(e) {
      this.bebanSPHVendor = e
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    dateFormat(value) {
      moment.locale('id')
      return moment(value).format('DD MMMM YYYY')
    },
    dateFormatIDN(value) {
      moment.locale('id')
      return moment(value, 'DD-MM-YYYY').format('DD MMMM YYYY')
    },
    clearForm() {
      this.bebanSPHVendor = '0'
      this.jumlahTagihan = ''
      this.tglTagihanAwal = ''
      this.tglTagihanAkhir = ''
    },
    checkedDisabled(item) {
      if (item.proyek_id_header !== null && item.id_header !== null) {
        if (
          this.rabs.find(
            (x) =>
              x.proyek_id === item.proyek_id_header && x.id === item.id_header
          ).selected === false
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    changeRab(checked, item) {
      this.rabs
        .filter(
          (x) =>
            x.proyek_id_header === item.proyek_id && x.id_header === item.id
        )
        .map((y) => {
          y.selected = checked
          this.rabs
            .filter(
              (z) => z.proyek_id_header === y.proyek_id && z.id_header === y.id
            )
            .map((o) => {
              o.selected = checked
            })
        })
    },
    checkedDisabledManual(item) {
      if (item.proyek_id_header !== null && item.id_header !== null) {
        if (
          this.rabs.find(
            (x) =>
              x.proyek_id === item.proyek_id_header && x.id === item.id_header
          ).selected === false
        ) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    changeRabManual(checked, item) {
      if (item.proyek_id_header === null && item.id_header === null) {
        this.rabs
          .filter(
            (x) =>
              x.proyek_id_header === item.proyek_id && x.id_header === item.id
          )
          .map((y) => {
            y.selected = checked
          })
      }
    },
    showModalTanggalBayar(noTagihan) {
      this.noTagihan = noTagihan
      this.modalUpdateBayar = true
    },
    toast(toaster, append = false, body) {
      this.$bvToast.toast(`Data ${this.title} ${body}`, {
        title: this.title,
        toaster: toaster,
        solid: true,
        appendToast: append,
        variant: 'success',
      })
    },
  },
}
</script>

<template>
  <div class="row pr-2 pl-2">
    <div
      v-if="items.length === 0 && user.role !== 'OPERASIONAL'"
      class="col-sm-12"
    >
      <label v-if="!kl || !baut || !bast" class="label-info-tagihan"
        >Mohon lengkapi dokumen KL, BAUT, dan BAST terlebih dahulu</label
      >
    </div>
    <div v-if="kl && baut && bast" class="col-sm-12">
      <div class="row mb-3">
        <div class="col-sm-6">
          <h5 class="m-0 font-weight-bold text-dark">
            {{ title }}
          </h5>

          <small class="text-muted">
            Setting dan buat draft tagihan proyek {{ detail.nama_proyek }}
          </small>
        </div>
        <div class="d-flex col-sm-6 justify-content-end gap-4">
          <b-dropdown
            text="Aksi Lainnya"
            variant="outline-primary"
            class="d-flex flex-col justify-content-center align-items-center height-36-px"
            right
          >
            <b-dropdown-item
              :disabled="
                detail.nilai_kontrak_prorate > detail.nilai_kontrak_belum_ppn &&
                  statusTagihan === 0
              "
              @click="showDraftManual"
            >
              <i class="fa fa-file-alt mr-1"></i>
              Draft Manual
            </b-dropdown-item>

            <b-dropdown-item
              :disabled="
                detail.nilai_kontrak_prorate > detail.nilai_kontrak_belum_ppn &&
                  statusTagihan === 0
              "
              @click="showDraftOtomatis"
            >
              <i class="fa fa-file-alt mr-1"></i>
              Draft Otomatis
            </b-dropdown-item>
          </b-dropdown>

          <button
            v-if="authorizedUser"
            class="btn btn-primary d-flex flex-col justify-content-center align-items-center height-36-px"
            :disabled="statusTagihan === 0"
            @click="saveDraft"
          >
            <span class="d-flex align-items-center gap-5">
              <i class="fa fa-save"></i>
              Simpan Draft
            </span>
          </button>

          <button
            v-if="authorizedUser"
            class="btn btn-danger d-flex flex-col justify-content-center align-items-center height-36-px"
            @click="resetDraft"
          >
            <span class="d-flex align-items-center gap-5">
              <i class="fa fa-undo"></i>
              Reset Draft
            </span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <CompTagihanInfo :detail="detail" :items="items" :margin="margin" />
        </div>
      </div>
      <CompTagihanTable
        :items="items"
        :detail="detail"
        :authorized-user="authorizedUser"
        @rincian-tagihan="rincianTagihan"
        @rincian-beban-vendor="rincianBebanVendor"
        @show-tanggal-bayar="showModalTanggalBayar"
        @remove="removeDraft"
        @add-detail="addDetail"
      />
    </div>
    <b-modal
      v-model="modalTagihan"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      size="lg"
      modal-class="modal-konfirmasi-tagihan"
    >
      <div>
        <div class="row">
          <div class="form-group col-sm-6">
            <label>Jenis </label>
            <b-form-select
              v-model="jenisTagihan"
              :options="jenisTagihans"
              value-field="id"
              text-field="name"
            >
            </b-form-select>
          </div>
          <div class="form-group col-sm-3">
            <label
              >Jumlah Tagihan
              {{ `${jenisTagihan === 'Bulan' ? '(Bulan)' : '(Hari)'}` }}</label
            >
            <input
              v-model="jumlahTagihan"
              type="text"
              class="form-control"
              @keypress="onlyNumber"
            />
          </div>
          <div class="form-group col-sm-3">
            <label>Jumlah Hari (Per Bulan)</label>
            <input
              v-model="jumlahHari"
              type="text"
              class="form-control"
              :disabled="jenisTagihan === 'Bulan'"
              @keypress="onlyNumber"
            />
          </div>
          <div class="form-group col-sm-6">
            <label>Tanggal Awal </label>
            <date-picker
              v-model="tglTagihanAwal"
              :config="{
                format: 'DD-MM-YYYY',
                useCurrent: false,
              }"
              :disabled="typeDraft !== 'new'"
            ></date-picker>
          </div>
          <div class="form-group col-sm-6">
            <label>Tanggal Akhir</label>
            <date-picker
              v-model="tglTagihanAkhir"
              :config="{
                format: 'DD-MM-YYYY',
                useCurrent: false,
              }"
              :disabled="typeDraft !== 'new'"
            ></date-picker>
          </div>
          <div class="form-group col-sm-6">
            <label>Beban Vendor</label>
            <comma-formatted-number
              :format-options="{ thousand: ',', precision: 0 }"
              :value="bebanSPHVendor"
              class="form-control"
              @input="handleBebanSPHVendor"
            />
          </div>
          <div class="col-sm-12">
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th rowspan="2">Aksi</th>
                    <th rowspan="2">No</th>
                    <th rowspan="2">Pekerjaan</th>
                    <th rowspan="2">VOL</th>
                    <th rowspan="2">Periode</th>
                    <th rowspan="2">SAT</th>
                    <th colspan="2">Harga Penawaran SPK</th>
                  </tr>
                  <tr>
                    <th>HARGA</th>
                    <th>JUMLAH</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in rabs" :key="index">
                    <td class="text-center">
                      <b-form-checkbox
                        v-model="item.selected"
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false"
                        class="ml-2"
                        :disabled="checkedDisabled(item)"
                        @change="changeRab($event, item)"
                      >
                      </b-form-checkbox>
                    </td>
                    <td class="th-td text-center"> {{ item.no }}</td>
                    <td class="th-td-35">{{ item.uraian_justifikasi }}</td>
                    <td
                      v-if="
                        item.volume !== null ||
                          (item.proyek_id_header === null &&
                            item.id_header === null)
                      "
                      class="text-center"
                      :rowspan="item.rowspan_volume"
                    >
                      {{ item.volume }}</td
                    >
                    <td
                      v-if="
                        item.periode !== null ||
                          (item.proyek_id_header === null &&
                            item.id_header === null)
                      "
                      class="text-center"
                      :rowspan="item.rowspan_periode"
                    >
                      {{ jumlahTagihan }}
                    </td>
                    <td
                      v-if="
                        item.periode !== null ||
                          (item.proyek_id_header === null &&
                            item.id_header === null)
                      "
                      class="text-center"
                      :rowspan="item.rowspan_periode"
                    >
                      {{
                        item.satuan !== null ? item.satuan.toUpperCase() : ''
                      }}</td
                    >
                    <td
                      v-if="
                        item.periode !== null ||
                          (item.proyek_id_header === null &&
                            item.id_header === null)
                      "
                      class="text-center"
                      :rowspan="item.rowspan_periode"
                    >
                      <b-input-group
                        v-if="item.spk !== null"
                        size="sm"
                        prepend="Rp"
                      >
                        <comma-formatted-number
                          :format-options="{ thousand: ',', precision: 0 }"
                          :value="item.spk.toString()"
                          class="form-control"
                          @input="handleSPK($event, item)"
                        />
                      </b-input-group>
                    </td>
                    <td
                      v-if="
                        item.periode !== null ||
                          (item.proyek_id_header === null &&
                            item.id_header === null)
                      "
                      class="text-center"
                      :rowspan="item.rowspan_periode"
                    >
                      {{
                        item.spk !== null
                          ? `Rp${(
                              item.spk *
                              (item.spk_kali !== 'all'
                                ? jumlahTagihan
                                : item.volume * jumlahTagihan)
                            )
                              .toFixed()
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                          : ''
                      }}</td
                    >
                  </tr>
                  <tr>
                    <td></td>
                    <td class="th-td-5 text-center"></td>
                    <td class="th-td-35"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"
                      >Rp
                      {{
                        items
                          .reduce(
                            (a, b) =>
                              a +
                              (b['spk'] *
                                (b['spk_kali'] !== 'all'
                                  ? b[b['spk_kali']]
                                  : b['volume'] * b['periode']) || 0),
                            0
                          )
                          .toFixed()
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      }}</td
                    >
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalTagihan = false"
          >Batal / Keluar</b-button
        >
        <b-button
          v-if="authorizedUser"
          type="button"
          variant="primary"
          :disabled="validationDraftManual"
          @click="draftManual"
          >Simpan Draft</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modalBebanVendor"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <div class="row">
          <div class="form-group col-sm-12">
            <label>Beban Vendor </label>
            <comma-formatted-number
              :format-options="{ thousand: ',', precision: 0 }"
              :value="bebanSPHVendor"
              class="form-control"
              @input="handleBebanSPHVendor"
            />
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalBebanVendor = false"
          >Batal / Keluar</b-button
        >
        <b-button type="button" variant="primary" @click="updateBebanVendor"
          >Update Beban Vendor</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modalKonfirmasiDraft"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      modal-class="modal-konfirmasi-tagihan"
      size="lg"
    >
      <div>
        <div class="row">
          <div class="col-sm-12 mb-4">
            <p v-if="nilaiKontrak === summarySpkVendor">
              Draft tagihan akan dibuat sesuai nilai kontrak &amp; RAB pada
              proyek
            </p>
            <p v-if="nilaiKontrak !== summarySpkVendor">
              Nilai kontrak pada proyek tidak sama dengan total spk vendor,
              silahkan cek kembali data proyek anda!!
            </p>
            <div class="col-sm-12">
              <table class="table table-sm table-bordered mb-2">
                <tbody>
                  <tr>
                    <td>Nilai Kontrak</td>
                    <td>{{
                      nilaiKontrak
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }}</td>
                  </tr>
                  <tr>
                    <td class="th-td-30">Total SPK Vendor</td>
                    <td>{{
                      summarySpkVendor
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }}</td>
                  </tr>
                  <tr>
                    <td class="th-td-30">Hitung normal</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <b-form-checkbox
                          v-model="hitungNormal"
                          :value="true"
                          :unchecked-value="false"
                        >
                        </b-form-checkbox>
                        <label class="mb-0"
                          >(Centang jika ingin hitung normal pada
                          prorate)</label
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-12">
              <div class="table-responsive">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th rowspan="2">Pilih</th>
                      <th rowspan="2">No</th>
                      <th rowspan="2">Uraian</th>
                      <th rowspan="2">VOL</th>
                      <th rowspan="2">Periode</th>
                      <th rowspan="2">SAT</th>
                      <th colspan="2" class="text-center">Harga SPH Vendor</th>
                      <th colspan="2" class="text-center"
                        >Harga Penawaran SPK</th
                      >
                    </tr>
                    <tr>
                      <th>HARGA</th>
                      <th>JUMLAH</th>
                      <th>HARGA</th>
                      <th>JUMLAH</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in rabs" :key="index">
                      <td class="text-center">
                        <b-form-checkbox
                          v-model="item.selected"
                          name="checkbox-1"
                          :value="true"
                          :unchecked-value="false"
                          class="ml-2"
                          :disabled="checkedDisabled(item)"
                          @change="changeRab($event, item)"
                        >
                        </b-form-checkbox>
                      </td>
                      <td class="text-center"> {{ item.no }}</td>
                      <td class="th-td-35">{{ item.uraian_justifikasi }}</td>
                      <td
                        v-if="
                          item.volume !== null ||
                            (item.proyek_id_header === null &&
                              item.id_header === null)
                        "
                        class="text-center"
                        :rowspan="item.rowspan_volume"
                      >
                        {{ item.volume }}</td
                      >
                      <td
                        v-if="
                          item.periode !== null ||
                            (item.proyek_id_header === null &&
                              item.id_header === null)
                        "
                        class="text-center"
                        :rowspan="item.rowspan_periode"
                      >
                        {{ item.periode }}</td
                      >
                      <td
                        v-if="
                          item.satuan !== null ||
                            (item.proyek_id_header === null &&
                              item.id_header === null)
                        "
                        class="text-center"
                        :rowspan="item.rowspan_satuan"
                      >
                        {{
                          item.satuan !== null ? item.satuan.toUpperCase() : ''
                        }}</td
                      >
                      <td
                        v-if="
                          item.sph !== null ||
                            (item.proyek_id_header === null &&
                              item.id_header === null)
                        "
                        class="text-center"
                        :rowspan="item.rowspan_sph"
                      >
                        {{
                          item.sph !== null && item.sph !== 0
                            ? `Rp${item.sph
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                            : ''
                        }}</td
                      >
                      <td
                        v-if="
                          item.sph !== null ||
                            (item.proyek_id_header === null &&
                              item.id_header === null)
                        "
                        class="text-center"
                        :rowspan="item.rowspan_sph"
                      >
                        {{
                          item.sph !== null && item.sph !== 0
                            ? `Rp${(
                                item.sph *
                                (item.sph_kali !== 'all'
                                  ? item[item.sph_kali]
                                  : item.volume * item.periode)
                              )
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                            : ''
                        }}</td
                      >
                      <td
                        v-if="
                          item.spk !== null ||
                            (item.proyek_id_header === null &&
                              item.id_header === null)
                        "
                        class="text-center"
                        :rowspan="item.rowspan_spk"
                      >
                        {{
                          item.spk !== null && item.spk !== 0
                            ? `Rp${item.spk
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                            : ''
                        }}</td
                      >
                      <td
                        v-if="
                          item.spk !== null ||
                            (item.proyek_id_header === null &&
                              item.id_header === null)
                        "
                        class="text-center"
                        :rowspan="item.rowspan_spk"
                      >
                        {{
                          item.spk !== null && item.spk !== 0
                            ? `Rp${(
                                item.spk *
                                (item.spk_kali !== 'all'
                                  ? item[item.spk_kali]
                                  : item.volume * item.periode)
                              )
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                            : ''
                        }}</td
                      >
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalKonfirmasiDraft = false"
          >Batal / Keluar</b-button
        >
        <b-button
          type="button"
          variant="primary"
          :disabled="summarySpkVendor !== nilaiKontrak"
          @click="buatDraft"
          >Buat Draft</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-if="rincianTagihans.length > 0"
      v-model="modalRincianTagihan"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
      size="lg"
    >
      <div>
        <div class="row">
          <div class="col-sm-12 mb-4">
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Qty</th>
                    <th>Satuan</th>
                    <th>Periode Tagih</th>
                    <th>Uraian Pekerjaan</th>
                    <th class="th-th-16"
                      >Harga Per
                      {{
                        rincianTagihans[0].jenis === 'Prorate'
                          ? 'Hari'
                          : rincianTagihans[0].jenis
                      }}</th
                    >
                    <th>Jumlah</th>
                    <!-- <th>Aksi</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in rincianTagihans" :key="index">
                    <td
                      v-if="item.qty !== null || item.type_field === 'header'"
                      :rowspan="item.rowspan_qty"
                      >{{ item.qty }}</td
                    >
                    <td
                      v-if="
                        item.satuan !== null || item.type_field === 'header'
                      "
                      :rowspan="item.rowspan_satuan"
                      >{{ item.satuan }}</td
                    >
                    <td
                      v-if="
                        item.periode_tagih !== null ||
                          item.type_field === 'header'
                      "
                      :rowspan="item.rowspan_periode"
                    >
                      {{ item.periode_tagih }}
                      {{ item.jenis === 'Prorate' ? 'Hari' : item.jenis }}
                    </td>
                    <td>{{ item.uraian_pekerjaan }}</td>
                    <td
                      v-if="item.harga !== null || item.type_field === 'header'"
                      :rowspan="item.rowspan_harga"
                    >
                      <b-input-group
                        v-if="item.harga !== null"
                        size="sm"
                        prepend="Rp"
                      >
                        <comma-formatted-number
                          :format-options="{ thousand: ',', precision: 0 }"
                          :value="item.harga.toString()"
                          class="form-control"
                          @input="handleHarga($event, item)"
                        />
                      </b-input-group>
                    </td>
                    <td
                      v-if="
                        item.jumlah !== null || item.type_field === 'header'
                      "
                      :rowspan="item.rowspan_jumlah"
                    >
                      {{
                        item.jumlah === null
                          ? ''
                          : 'Rp' +
                            item.jumlah
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right font-weight-bold" colspan="4">
                      Total :
                    </td>
                    <td>
                      Rp{{
                        rincianTagihans
                          .reduce((a, b) => a + (b['harga'] || 0), 0)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      }}
                    </td>
                    <td>
                      Rp{{
                        rincianTagihans
                          .reduce((a, b) => a + (b['jumlah'] || 0), 0)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalRincianTagihan = false"
          >Keluar</b-button
        >
        <b-button
          class="mr-2"
          type="button"
          variant="primary"
          @click="updateRincianTagihan"
          >Update Rincian Tagihan</b-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="modalUpdateBayar"
      title-class="text-center"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div>
        <div class="row">
          <div class="form-group col-sm-12">
            <label
              >Tanggal<span
                v-if="tanggalBayar === ''"
                class="text-danger font-size-11 font-italic"
                >*Harus Diisi</span
              ></label
            >
            <date-picker
              v-model="tanggalBayar"
              :config="dateOptions"
            ></date-picker>
          </div>
        </div>
      </div>
      <div class="text-right">
        <b-button
          class="mr-2"
          type="button"
          variant="outline-primary"
          @click="modalUpdateBayar = false"
          >Batal / Keluar</b-button
        >
        <b-button type="button" variant="primary" @click="updateTanggalBayar"
          >Update Tanggal Bayar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.area-draft {
  margin-left: 0px;
  margin-right: 0px;
  border: 1px dashed #5369f8;
  height: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    font-size: 36px;

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      color: #8acbff !important;
      &:hover {
        color: #8acbff !important;
      }
    }
  }
}

.label-info-tagihan {
  width: 100%;
  background-color: #ffeed6;
  padding: 10px;
  font-weight: 700;
}
.input-group {
  .input-group-prepend {
    .input-group-text {
      border: none;
      padding: 0px 1px;
      // background: #1984ff !important;
      background: white;
      color: black !important;
      font-weight: bold;
      font-size: 11px;
    }
  }
  .form-control {
    border: none;
    font-size: 11px;
    font-weight: bold;
    padding: 0px 5px;
    // background: #1984ff;
    color: black;
  }
}
.btn-link {
  text-decoration: underline !important;
}
</style>
